import * as dialog from 'plugins/dialog';

import BaseModal from '@/legacy/modals/BaseModal';

declareModules({
  'modals/manage/popup.html': () => import('@/legacy/modals/manage/popup.html'),
});

class ManagePayee extends BaseModal {
  view = 'modals/manage/popup';

  public params: any;

  /** Used to prevent a call cycle when trying to close a popup. */
  public isClosing = false;

  private static lastScrollTop = 0;

  public Close(): void {
    // Restore scroll position
    $('#scroll-container').css({ height: 'auto', overflow: 'initial' });
    $(window).scrollTop(ManagePayee.lastScrollTop);

    const addedDialog = dialog.getDialog(this) as any;
    $(addedDialog.host)
      .css('position', 'fixed')
      .addClass('scale-out')
      .animate(
        {
          opacity: 0,
        },
        300,
        () => {
          dialog.close(this);
        }
      );
  }

  public static show(view: string, params: any = undefined): ManagePayee {
    // Store scroll position (Content can be massive but the popup is small)
    ManagePayee.lastScrollTop = $(window).scrollTop();
    $('#scroll-container')
      .height($(window).height())
      .css('overflow', 'hidden')
      .scrollTop(ManagePayee.lastScrollTop);
    $(window).scrollTop(0);

    const dialogOptions = new ManagePayee();
    dialogOptions.params = params;
    dialogOptions.view = view;
    dialog.show(dialogOptions, undefined, 'modal');

    const addedDialog = dialog.getDialog(dialogOptions) as any;
    $(addedDialog.host).addClass('manage-modal-host');
    $(addedDialog.host).data('modal', dialogOptions);
    return dialogOptions;
  }

  public getView() {
    return this.view;
  }

  public resizeWrapper() {
    $(window).trigger('resize');
  }
}

export default ManagePayee;
